export default {
    methods: {
        listen(channel, event, handler) {
            let listenTo = event;

            if (!listenTo.startsWith('.')) {
                listenTo = '.' + listenTo;
            }

            window.Echo.private(channel).listen(listenTo, handler);
        },

        listenUser(firebaseUid, event, handler) {
            this.listen('users.' + firebaseUid, event, handler);
        },

        listenAuthUser(event, handler) {
            if (this.$page.props.auth_uid === undefined) {
                throw new Error(`Can't subscribe to '${event}' because auth_uid is undefined.`);
            }

            if (this.$page.props.auth_uid === null) {
                throw new Error(`Can't subscribe to '${event}' because auth_uid is null.`);
            }

            this.listenUser(this.$page.props.auth_uid, event, handler);
        }
    }
};
